<template>
  <div
    class="roomCard"
    :class="(currentRoomIndex !== null ? (active ? 'active' : 'otherRoom') : '')"
  >
  <div
    class="bar"
    :style="styleBar"
  ></div>
    <div
      class="roomHead"
      @click="enterRoom"
    >
      <div
        class="number"
        :class="{'invert' : this.invert}"
        :style="{backgroundColor: room.color}"
      >
        {{ this.room.number }}
      </div>
      <div class="roomHeadContent">
        <h3>{{ room.title }}</h3>
        <p>{{ room.teaser }}</p>
      </div>
    </div>
    <div
      v-if="active"
      class="exhibits"
    >
      <Exhibit
        v-for="(exhibit, exhibitIndex) in room.exhibits"
        :key="exhibitIndex"
        :exhibit="exhibit"
        :index="exhibitIndex"
        :roomColor="room.color"
        :invert="invert"
      />
  </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Exhibit from './Exhibit.vue';

export default {
  components: {
    Exhibit,
  },
  props: {
    room: {
      type: Object,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      invert: false,
    };
  },
  computed: {
    ...mapGetters(['currentFloorIndex', 'currentRoomIndex', 'currentExhibit', 'backgroundPattern']),
    styleBar() {
      return {
        backgroundColor: this.room.color,
        backgroundImage: this.backgroundPattern, // UGLY SHIT
      };
    },
  },
  methods: {
    ...mapActions(['setRoomIndex', 'resetNavigation']),
    enterRoom() {
      if (this.active) {
        this.resetNavigation();
        if (process.env.VUE_APP_DEBUG === 'on') console.log(' from RoomCard resetNavigation');
      } else {
        this.setRoomIndex(this.room.id);
        this.$router.push({ name: 'Room', params: { roomId: this.room.id } });
        if (process.env.VUE_APP_DEBUG === 'on') console.log(' from RoomCard');
      }
    },
  },
  watch: {
    currentRoomIndex(newValue, oldValue) {
      if (this.floorIndex === 0) {
        console.log(`${this.room.id} ${this.currentRoomIndex} old: ${oldValue} new: ${newValue} ${this.active} ${this.active}`);
        // console.log(this.$store);
      }
    },
  },
  mounted() {
    this.invert = this.$helper.isBrightHSL(this.room.color);
    if (this.floorIndex === 0) { console.log(this.index); }
  },
};
</script>

<style scoped lang="scss">
.roomCard {
  position: relative;
  color: var(--main-text-color);
  display: block;
  /* overflow: hidden; */
  box-sizing: border-box;

  .bar{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%; // UGLY SHIT
    width: 30px; // UGLY SHIT
    background-size: 50px;
    background-repeat: repeat;
    z-index: -9999;

    /* The good stuff
    left: 19px;
    width: 2px; */
  }

  .roomHead {
    display: flex;

    .number {
      box-sizing: border-box;
      width: 30px; // UGLY SHIT
      height: 60px; // UGLY SHIT
      font-size: 1.2em;
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
      color: var(--main-text-color-invert);
      margin-bottom: 7vh;
      margin-bottom: calc(var(--vh, 1vh) * 7);

      /* The good stuff
      width: 40px;
      height: 40px;
      border-radius: 20px; */
    }
    .roomHeadContent{
      padding: 9px 12px 3vh 12px;
      padding: 9px 12px calc(var(--vh, 1vh) * 3) 12px;
      /*padding: 9px 12px 2em 12px;*/
      /* margin-bottom: 30px; */
      flex: 1;
    }
  }
  h3 {
    margin: 0;
    padding: 0;
    text-transform: uppercase; // UGLY SHIT
    font-size: 1em;
  }
  p {
    margin: 0;
    padding: 0;
    margin-top: 3px;
    /* font-size: .9em;
    font-weight: bold; */
  }
  .exhibits {
    display: none;
    overflow: visible;
  }
  /* .roomCard */
  &.active {
    margin-top: 4vh;
    margin-top: calc(var(--vh, 1vh) * 4);

    .bar{
      min-height: 73vh;
      min-height: calc(var(--vh, 1vh) * 73);
    }

    .roomHead {
      .number {
        margin-bottom: 0;
      }
    }

    .exhibits {
      display: block;
    }
  }
  /* .roomCard */
  &.otherRoom {
    display: none;
  }

  @media (prefers-color-scheme: light) {
    .number {
      &.invert {
        color: var(--main-text-color);
      }
    }
  }
  @media (prefers-color-scheme: dark) {
    .number {
      &.invert {
        color: var(--main-text-color-invert);
      }
    }
  }
}
@media only screen and (orientation : landscape) {
  .roomCard {
    &.active {
      min-height: none;
      margin-top: 0;
    }
  }
}
</style>
